module.exports = __webpack_public_path__ + "block-2-1x-9ecf56e1080e6ee03e9bb9a84b5ff6ec.webp";